export default __webpack_public_path__ + "static/media/btnIos.cb1cc653.svg";